export default {
	action: 'Action',
	amount: 'Amount',
	available_balance: 'Available Balance:',
	credit_info: 'Credit Info',
	credit_invoice_no: 'Credit Invoice No.',
	email_bound: 'Email Bound',
	email_unbound: 'Email Unbound',
	pay: 'Pay',
	recharge_now: 'Top Up',
	set_password_notice: 'Please set your password as soon as possible',
	status: 'Status',
	unverified: 'Unverified',
	verified: 'Verified',
	view_invoice: 'View Invoice',
	welcome_back: 'Welcome back, ',
}
